import type { WalletsState } from './types';

const initialState: WalletsState = {
  addresses: [],
};

export default initialState;
